import Vue from "vue";
import Router from "vue-router";
import index from "@/view/index"
import industry_information from "@/view/industry_information/industry_information"
import info_detail from "@/view/industry_information/info_detail"
import technology from "@/view/technology/technology"
import technology_detail from "@/view/technology/technology_detail"
import environmental_housekeeper from "@/view/environmental_housekeeper"
import home from "@/view/home"
import classification_list from "@/view/home/classification_list"
import data_center from "@/view/data_center"
import data_detail from "@/view/data_detail"
import supply_demand from "@/view/supply_demand/supply_demand"
import supply_detail from "@/view/supply_demand/supply_detail"
import demand_detail from "@/view/supply_demand/demand_detail"
import supply_project from "@/view/supply_demand/supply_project"  //项目信息
import project_detail from "@/view/supply_demand/project_detail"   //项目信息详情
import college from "@/view/college"
import environmental_college from "@/view/college/environmental_college"
import environmental_college_detail from "@/view/college/environmental_college_detail"
import enterprise_interview_detail from "@/view/college/enterprise_interview_detail"

import other from "@/view/other"
import help_detail from "@/view/other/help_detail"
import help_center from "@/view/other/help_center"
import advertising_services from "@/view/other/advertising_services"
import chapter_users from "@/view/other/chapter_users"
import contact_us from "@/view/other/contact_us"
import payment_information from "@/view/other/payment_information" //支付
import mobile_phone from "@/view/other/mobile_phone"
import platform_entry from "@/view/other/platform_entry"
import expert_list from "@/view/other/expert_list"
import expert_detail from "@/view/other/expert_detail"   //专家详情
import activity_list from "@/view/other/activity_list"
import jicai_activity_list from "@/view/other/jicai_activity_list"
import activity_detail from "@/view/other/activity_detail"   //活动详情
import jicai_activity_detail from "@/view/other/jicai_activity_detail"   //活动详情
import payment from "@/view/other/payment" // 余额支付
import alipay_dialog from "@/view/other/alipay_dialog" //
import searchIndex from "@/view/other/searchIndex"  //首页搜索展示
import summary_demand from "@/view/other/summary_demand"  //需求汇总
import exhibition_detail from "@/view/other/exhibition_detail"  //展会详情
import exhibition_list from "@/view/other/exhibition_list"  //展会详情


import login from "@/view/login"
import register from "@/view/register"
import retrieve from "@/view/retrieve"



import company from "@/view/company"
import corporate_account from "@/view/company/corporate_account" //企业账号--审核
import corporate_case from "@/view/company/corporate_case" //经典案例
import corporate_caseAdd from "@/view/company/corporate_caseAdd" //经典案例-添加案列
import corporate_supply from "@/view/company/corporate_supply" // 供应信息
import corporate_supplyAdd from "@/view/company/corporate_supplyAdd" //添加供应
import corporate_owned from "@/view/company/corporate_owned" //企业资讯
import corporate_qualifications from "@/view/company/corporate_qualifications" //企业资质
import corporate_news from "@/view/company/corporate_news" //企业信息
import corporate_attestation from "@/view/company/corporate_attestation" //企业认证
import corporate_introduce from "@/view/company/corporate_introduce" // 企业介绍
import corporate_detail from "@/view/company/corporate_detail" //企业详情
import corporate_member from "@/view/company/corporate_member" //企业用户升级缴费
import corporate_list from "@/view/company/corporate_list"  //企业资讯
import corporate_demand  from "@/view/company/corporate_demand"
import corporate_invoice from "@/view/company/corporate_invoice"  //发票申请列表
import corporate_invoiceAdd from "@/view/company/corporate_invoiceAdd"  //添加申请发票
import corporate_card from "@/view/company/corporate_card"


import corporate from "@/view/corporate"
import corporate_list_all from "@/view/corporate/corporate_list_all"  //公司资讯
import corporate_case_all from "@/view/corporate/corporate_case_all" //企业案例
import corporate_case_detail from "@/view/corporate/corporate_case_detail" //企业案列详情
import corporate_supply_all from "@/view/corporate/corporate_supply_all" //企业供应


import expert from "@/view/expert"
import expert_income from "@/view/expert/expert_income" //专家账户-收入
import expert_angle from "@/view/expert/expert_angle" //专家账户-专家视角
import expert_angleAdd from "@/view/expert/expert_angleAdd" //专家账户-专家视角-添加文章
import expert_curriculum from "@/view/expert/expert_curriculum" //专家账户-课程
import expert_activity from "@/view/expert/expert_activity" //专家账户-活动
import expert_problem from "@/view/expert/expert_problem" //专家账户-问题

/***
 * 公共页面
 */
import coment from "@/view/coment"
import income from "@/view/coment/income"  //需求
import demand from "@/view/coment/demand"  //需求
import demandAdd from "@/view/coment/demandAdd" //添加需求
import demandDetail from "@/view/coment/demandDetail" //个人中心需求详情
import means from "@/view/coment/means"   //资料
import meansAdd from "@/view/coment/meansAdd"   //添加资料
import meansDetail from "@/view/coment/meansDetail"   //资料详情
import problem from "@/view/coment/problem"   //问题
import problemDetail from "@/view/coment/problemDetail"
import download from "@/view/coment/download"   //下载
import collection from "@/view/coment/collection"   //收藏
import activity from "@/view/coment/activity"   //活动
import jicai_activity from "@/view/coment/jicai_activity"   //活动
import curriculum from "@/view/coment/curriculum"   //课程
import curriculumDetail from "@/view/coment/curriculumDetail"   //课程详情
import password_change from "@/view/coment/password_change"   //修改密码
import membership from "@/view/coment/membership" //会员权益
import message from "@/view/coment/message" //会员权益
import personal_information from "@/view/coment/personal_information" //个人信息-编辑
import withdrawal from "@/view/coment/withdrawal" // 提现
import number from "@/view/coment/number" // 提现
import integral from "@/view/integralPage/integral"  // 积分


import { frontBrowseSave } from "../api/coment";
import axios from 'axios';

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location) && originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [{
      path: "/",
      name: "index",
      component: index,
      meta:{
        title:'首页'
      }
    },
    {
      path: "/industry_information",
      name: "industry_information",
      meta: {
        title: "行业资讯"
      },
      component: industry_information,
    },
    {
      path: "/info_detail",
      name: "info_detail",
      meta: {
        title: "资讯详情"
      },
      component: info_detail,
    },
    {
      path: "/technology",
      name: "technology",
      meta: {
        title: "环保技术"
      },
      component: technology,
    },
    {
      path: "/technology_detail",
      name: "technology_detail",
      meta: {
        title: "技术详情"
      },
      component: technology_detail,
    },
    {
      path: "/environmental_housekeeper",
      name: "environmental_housekeeper",
      meta: {
        title: "环保管家"
      },
      component: environmental_housekeeper
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children: [{
        path: "/classification_list",
        name: "classification_list",
        meta: {
          title: '首页 -分类'
        },
        component: classification_list
      }]
    },
    {
      path: "/data_center",
      name: "data_center",
      meta: {
        title: "资料中心"
      },
      component: data_center,
    },
    {
      path: "/data_detail",
      name: "data_detail",
      meta: {
        title: "资料中心-资料详情"
      },
      component: data_detail,
    },
    {
      path: "/supply_demand",
      name: "supply_demand",
      meta: {
        title: "供需平台"
      },
      component: supply_demand
    },
    {
      path: "/supply_project",
      name: "supply_project",
      meta: {
        title: "项目信息"
      },
      component: supply_project
    },
    {
      path: "/supply_detail",
      name: "supply_detail",
      meta: {
        title: "供应详情"
      },
      component: supply_detail
    },
    {
      path: "/demand_detail",
      name: "demand_detail",
      meta: {
        title: "需求详情"
      },
      component: demand_detail
    },
    {
      path: "/enterprise_interview_detail",
      name: "enterprise_interview_detail",
      meta: {
        title: "专访详情"
      },
      component: enterprise_interview_detail
    },
    {
      path: '/college',
      name: 'college',
      component: college,
      children: [{
        path: "/environmental_college",
        name: "environmental_college",
        meta: {
          title: '环学院'
        },
        component: environmental_college
      }, {
        path: "/environmental_college_detail",
        name: "environmental_college_detail",
        meta: {
          title: '环学院-课件详情'
        },
        component: environmental_college_detail
      }]
    },
	{
		path:'/corporate',
		name:'corporate',
		component: corporate,
		children:[
		  {
			  path: "/corporate_list_all",
			  name: "corporate_list_all",
			  meta: {
			    title: "企业供应产品"
			  },
			  component: corporate_list_all
			},
			{
			  path: "/corporate_supply_all",
			  name: "corporate_supply_all",
			  meta: {
			    title: "企业供应产品"
			  },
			  component: corporate_supply_all
			},
			{
			  path: "/corporate_case_all",
			  name: "corporate_case_all",
			  meta: {
			    title: "经典案例"
			  },
			  component: corporate_case_all
      },
      {
			  path: "/corporate_case_detail",
			  name: "corporate_case_detail",
			  meta: {
			    title: "案例详情"
			  },
			  component: corporate_case_detail
      },


		]
	},
    {
      path: '/company',
      name: 'company',
      component: company,
      children: [
		{
		  path: "/corporate_demand",
		  name: "corporate_demand",
		  meta: {
		    title: "企业需求"
		  },
		  component: corporate_demand
		},
        {
          path: "/corporate_owned",
          name: "corporate_owned",
          meta: {
            title: "企业资讯-新增资讯"
          },
          component: corporate_owned
        },
        {
          path: "/corporate_list",
          name: "corporate_list",
          meta: {
            title: "企业资讯"
          },
          component: corporate_list
        },
        {
          path: "/corporate_attestation",
          name: "corporate_attestation",
          meta: {
            title: "企业资讯审核"
          },
          component: corporate_attestation
        },
        {
          path: "/corporate_card",
          name: "corporate_card",
          meta: {
            title: "完善身份信息"
          },
          component: corporate_card
        },
        {
          path: "/corporate_account",
          name: "corporate_account",
          meta: {
            title: "个人中心"
          },
          component: corporate_account
        },
        {
          path: "/corporate_supply",
          name: "corporate_supply",
          meta: {
            title: "企业供应信息"
          },
          component: corporate_supply
        },
        {
          path: "/corporate_supplyAdd",
          name: "corporate_supplyAdd",
          meta: {
            title: "企业供应-添加供应"
          },
          component: corporate_supplyAdd
        },
        {
          path: "/corporate_news",
          name: "corporate_news",
          meta: {
            title: "企业信息"
          },
          component: corporate_news
        },
        {
          path: "/corporate_qualifications",
          name: "corporate_qualifications",
          meta: {
            title: "企业资质"
          },
          component: corporate_qualifications
        },
        {
          path: "/corporate_case",
          name: "corporate_case",
          meta: {
            title: "经典案例"
          },
          component: corporate_case
        },
        {
          path: "/corporate_caseAdd",
          name: "corporate_caseAdd",
          meta: {
            title: "经典案例-添加案列"
          },
          component: corporate_caseAdd

        },
        {
          path: "/corporate_detail",
          name: "corporate_detail",
          meta: {
            title: "企业详情"
          },
          component: corporate_detail
        },
        {
          path: "/corporate_introduce",
          name: "corporate_introduce",
          meta: {
            title: "企业介绍"
          },
          component: corporate_introduce
        },
        {
          path: "/corporate_member",
          name: "corporate_member",
          meta: {
            title: "企业用户升级缴费"
          },
          component: corporate_member
        },{
          path: "/corporate_invoice",
          name: "corporate_invoice",
          meta: {
            title: "发票申请"
          },
          component: corporate_invoice
        },{
          path: "/corporate_invoiceAdd",
          name: "corporate_invoiceAdd",
          meta: {
            title: "添加申请"
          },
          component: corporate_invoiceAdd
        }
      ]
    },
    {
      path: "/expert",
      name: "expert",
      component: expert,
      children: [ {
          path: "/expert_income",
          name: "expert_income",
          meta: {
            title: "专家账号-收入"
          },
          component: expert_income
        }, {
          path: "/expert_angle",
          name: "expert_angle",
          meta: {
            title: "专家账号-专家视角"
          },
          component: expert_angle
        }, {
          path: "/expert_angleAdd",
          name: "expert_angleAdd",
          meta: {
            title: "专家账号-专家视角-添加文章"
          },
          component: expert_angleAdd
        }, {
          path: "/expert_curriculum",
          name: "expert_curriculum",
          meta: {
            title: "专家账号-课程"
          },
          component: expert_curriculum
        }, {
          path: "/expert_activity",
          name: "expert_activity",
          meta: {
            title: "专家账号-活动"
          },
          component: expert_activity
        }, {
          path: "/expert_problem",
          name: "expert_problem",
          meta: {
            title: "专家账号-问题"
          },
          component: expert_problem
        }

      ]
    },
    {
      path: "/other",
      name: "other",
      component: other,
      children: [{
          path: "/help_detail",
          name: "help_detail",
          meta: {
            title: "帮助详情"
          },
          component: help_detail
        },
        {
          path: "/help_center",
          name: "help_center",
          meta: {
            title: "帮助中心"
          },
          component: help_center
        },
        {
          path: "/advertising_services",
          name: "advertising_services",
          meta: {
            title: "广告服务"
          },
          component: advertising_services
        },
        {
          path: "/chapter_users",
          name: "chapter_users",
          meta: {
            title: "关于我们"
          },
          component: chapter_users
        },
        {
          path: "/contact_us",
          name: "contact_us",
          meta: {
            title: "联系我们"
          },
          component: contact_us
        },
        {
          path: "/payment_information",
          name: "payment_information",
          meta: {
            title: "支付信息"
          },
          component: payment_information
        },{
          path: "/payment",
          name: "payment",
          meta: {
            title: '余额充值'
          },
          component: payment
        },
        {
          path: "/mobile_phone",
          name: "mobile_phone",
          meta: {
            title: "绑定手机"
          },
          component: mobile_phone
        },
        {
          path: "/platform_entry",
          name: "platform_entry",
          meta: {
            title: "入驻平台"
          },
          component: platform_entry
        },
        {
          path: "/expert_list",
          name: "expert_list",
          meta: {
            title: "环保达人"
          },
          component: expert_list
        },
        {
          path: "/expert_detail",
          name: "expert_detail",
          meta: {
            title: "专家库-详情"
          },
          component: expert_detail
        },
        {
          path: "/activity_list",
          name: "activity_list",
          meta: {
            title: "活动"
          },
          component: activity_list
        },
        {
          path: "/jicai_activity_list",
          name: "jicai_activity_list",
          meta: {
            title: "集采活动"
          },
          component: jicai_activity_list
        },
        {
          path: "/project_detail",
          name: "project_detail",
          meta: {
            title: "项目详情"
          },
          component: project_detail
        },
        {
          path: "/activity_detail",
          name: "activity_detail",
          meta: {
            title: "活动详情"
          },
          component: activity_detail
        },
        {
          path: "/jicai_activity_detail",
          name: "jicai_activity_detail",
          meta: {
            title: "活动详情"
          },
          component: jicai_activity_detail
        },
        {
          path: "/alipay_dialog",
          name: "alipay_dialog",
          meta: {
            title: "alipay_dialog"
          },
          component: alipay_dialog
        },{
          path: "/searchIndex",
          name: "searchIndex",
          meta: {
            title: "首页搜索"
          },
          component: searchIndex
        },{
          path: "/summary_demand",
          name: "summary_demand",
          meta: {
            title: "需求汇总"
          },
          component: summary_demand
        },{
          path: "/exhibition_detail",
          name: "exhibition_detail",
          meta: {
            title: "展会详情"
          },
          component: exhibition_detail
        },{
          path: "/exhibition_list",
          name: "exhibition_list",
          meta: {
            title: "平台展会"
          },
          component: exhibition_list
        }
      ]
    }, {
      path: "/login",
      name: "login",
      meta: {
        title: "登录"
      },
      component: login
    }, {
      path: "/register",
      name: "register",
      meta: {
        title: "注册"
      },
      component: register
    }, {
      path: "/retrieve",
      name: "retrieve",
      meta: {
        title: "找回密码"
      },
      component: retrieve
    },
    {
      path: '/coment',
      name: 'coment',
      component: coment,
      children:[{
        path: "/income",
        name: "income",
        meta: {
          title: '收入'
        },
        component: income
       },{
        path: "/integral",
        name: "integral",
        meta: {
          title: '积分'
        },
        component: integral
       },{
        path: "/demand",
        name: "demand",
        meta: {
          title: '需求'
        },
        component: demand
      },{
        path: "/demandAdd",
        name: "demandAdd",
        meta: {
          title: '添加需求'
        },
        component: demandAdd
      },{
        path: "/demandDetail",
        name: "demandDetail",
        meta: {
          title: '需求详情'
        },
        component: demandDetail
      },
      {
        path: "/means",
        name: "means",
        meta: {
          title: '资料'
        },
        component: means
      },
      {
        path: "/meansAdd",
        name: "meansAdd",
        meta: {
          title: '添加资料'
        },
        component:meansAdd
      },
      {
        path: "/meansDetail",
        name: "meansDetail",
        meta: {
          title: '资料详情'
        },
        component:meansDetail
      },
      {
        path: "/problem",
        name: "problem",
        meta: {
          title: '问题'
        },
        component: problem
      },
      {
        path: "/problemDetail",
        name: "problemDetail",
        meta: {
          title: '问题详情'
        },
        component: problemDetail
      },{
        path: "/download",
        name: "download",
        meta: {
          title: '下载'
        },
        component: download
      },{
        path: "/collection",
        name: "collection",
        meta: {
          title: '收藏'
        },
        component: collection
      },{
        path: "/activity",
        name: "activity",
        meta: {
          title: '活动'
        },
        component: activity
      },{
          path: "/jicai_activity",
          name: "jicai_activity",
          meta: {
            title: '集采活动'
          },
          component: jicai_activity
        },{
        path: "/curriculum",
        name: "curriculum",
        meta: {
          title: '课程'
        },
        component: curriculum
      },{
        path: "/curriculumDetail",
        name: "curriculumDetail",
        meta: {
          title: '课程详情'
        },
        component: curriculumDetail

      },{
        path: "/password_change",
        name: "password_change",
        meta: {
          title: '修改密码'
        },
        component: password_change
      },{
        path: "/membership",
        name: "membership",
        meta: {
          title: "会员权益"
        },
        component: membership
      },{
        path: "/message",
        name: "message",
        meta: {
          title: "消息中心"
        },
        component: message
      },{
        path: "/personal_information",
        name: "personal_information",
        meta: {
          title: "个人信息-编辑"
        },
        component: personal_information
      },{
        path: "/withdrawal",
        name: "withdrawal",
        meta: {
          title: "用户提现"
        },
        component:withdrawal
      },{
        path: "/number",
        name: "number",
        meta: {
          title: "个人中心"
        },
        component:number
      }]
    }
  ]
});

// 获取开始时间
// let startTime = Date.now()

// 用户浏览记录
const browsingHistory = (to,from) => {
  // let currentTime = Date.now();
  let Brow_history = {
    preUrl: from.path,
    preTitle: from.meta.title,
    currentTitle: to.meta.title,
    currentUrl: to.path,
    name: "未登录"
  }
  // console.log(Brow_history)
  
  if(localStorage.getItem('data')){
     Brow_history.name = (JSON.parse(localStorage.getItem('data'))).data.name
  }else{
    if(localStorage.getItem('temporary')){
      Brow_history.name = localStorage.getItem('temporary')
    }else{
      var temporaryUser = new Date().valueOf()
      localStorage.setItem('temporary',"游客" + temporaryUser)
      Brow_history.name = "游客" + temporaryUser
    }
  }

    // console.log(
    //   "用户信息: ",Brow_history.name,";  浏览页面：",to.path,"; 页面描述：",to.meta.title,"; IP归属地：",localStorage.getItem('cityname'),"; 浏览时间：",Date.now(),";"
    // );
    frontBrowseSave({
      username: Brow_history.name,
      path: to.path,
      pathDescribe: to.meta.title,
      // address: localStorage.getItem('cityname'),
   }).then((res) => {
     // console.log("保存成功")
     // console.log(res)
   })

  // startTime = Date.now()
}

router.beforeEach((to, from, next) => {
  // NProgress.start();
  browsingHistory(to,from);
  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js